import { tr } from '@/lib/i18n-core';
import { cn, humanize } from '@/lib/utils';
import { triageEntry } from './er-board';

export function TriageChip({ level }: { level: string | null }) {
  if (level === null) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full border border-dashed px-2 py-0.5 text-xs font-medium text-muted-foreground">
        {tr('opd', 'er_not_triaged')}
      </span>
    );
  }
  const entry = triageEntry(level);
  return (
    <span className={cn('inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold', entry?.className)}>
      {entry ? `${entry.rank} · ${entry.label}` : humanize(level)}
    </span>
  );
}
